import { CROSS_WINDOW_MESSAGE_PREFIX, } from './types';
// Export all message types
export * from './types';
export const isCrossWindowMessage = (data) => {
    if (!data || typeof data !== 'object') {
        return false;
    }
    const { type } = data;
    return (typeof type === 'string' && type.startsWith(CROSS_WINDOW_MESSAGE_PREFIX));
};
export const postCrossWindowMessage = (target, type, payload, targetOrigin = '*') => {
    target === null || target === void 0 ? void 0 : target.postMessage({
        payload: JSON.stringify(payload),
        type,
    }, { targetOrigin });
};
